import { render } from "./ContactUsButton.vue?vue&type=template&id=341960ca&scoped=true"
import script from "./ContactUsButton.vue?vue&type=script&lang=js"
export * from "./ContactUsButton.vue?vue&type=script&lang=js"

import "./ContactUsButton.vue?vue&type=style&index=0&id=341960ca&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341960ca"]])

export default __exports__